export const COVEO_INDEXING_FEATURE_TOKEN = 'coveo-indexing';
export const SEARCH_ANALYTICS_DATA_ATTRIBUTES_SCOPE = 'search-analytics';
export const SEARCH_ANALYTICS_FEATURE_TOKEN = 'search-analytics';
